import { Component, ViewChild, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotyService } from '../../../services/common/noty.service';
import { ScansService } from '../../../services/scans/scans.service';
import { MatterSearchComponent } from '../../common/matter-search/matter-search.component';
import { ContactSearchComponent } from '../../common/contact-search/contact-search.component';
import { DocumentSearchComponent } from '../../common/document-search/document-search.component';
import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/common/auth.service';
import { DocumentTypeService } from '../../../services/documents/document-type.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-scan-edit',
  templateUrl: './scan-edit.component.html',
  styleUrls: ['./scan-edit.component.scss']
})
export class ScanEditComponent implements OnInit {

  scan: any = {
    authored_on:"",
    document_type_id: null,
    has_problems: false,
    skip_rules: false,
    notes: "",
    amount: null,
    tags: "",
    exhibit: null,
    id: this.route.snapshot.paramMap.get('id')
  }
  accepting: boolean = false;
  authors: Array<any> = [];
  availableAuthors: Array<any> = [];
  pdfUrl: string = "";
  deleting: boolean = false;
  deleteWarningMessage: string = '';
  scanId: number = Number(this.route.snapshot.paramMap.get('id'));
  deletingAuthor: boolean = false;
  deletingMatter: boolean = false;
  oldAuthors: Array<any> = [];
  oldMatters: Array<any> = [];
  matters: Array<any> = [];
  documentType: any = {};
  selectedDocumentType: Array<any> = [];
  areDatesPresent: Boolean = false;
  newScanAuthor: any;
  scanDates: Array<any> = [];
  released: Boolean = false;
  isAttorneyReviewing: Boolean = false;
  isScanFininshed: Boolean = false;
  isScanProcessing: Boolean = false;
  isScannerReviewing: Boolean = false;
  scannerFormResponse: string = "";
  attorneyFormResponse: string = "";
  scanProblems: any = undefined;
  scannerResponse: any = undefined;
  saving: boolean = false;
  loading: boolean = true;
  intakeReleaseContext: any = {};
  text: string;
  page_count: number;

  url: string = '';

  /**
   * Matter search component
   * @param {[type]} 'matterSearch'
  */
   @ViewChild('matterSearch') matterSearchComponent: MatterSearchComponent;

  /**
   * Contact search component
   * @param {[type]} 'contactSearch'
  */
   @ViewChild('contactSearch') contactSearchComponent: ContactSearchComponent;

  /**
   * Documnet search component
   * @param {[type]} 'documentSearch'
  */
   @ViewChild('documentSearch') documentSearchComponent: DocumentSearchComponent;

   @ViewChild('confirmDeleteModal', { static: true }) confirmDeleteModalTemplateRef: TemplateRef<any>;

  constructor(private authService: AuthService,
              private documentTypeService: DocumentTypeService,
              private router: Router,
              private route: ActivatedRoute,
              private ngbModalService: NgbModal,
              private notyService: NotyService,
              private scansService: ScansService) {
    if(environment.url && environment.url.indexOf(window.location.origin) < 0) {
      this.url = environment.url;
    }
  }

  ngOnInit(): void {
    this.getScanDetails();
  }

  getScanDetails() {
    this.scansService.edit(this.scanId).then(response_json=>{
      this.loading = false;
      this.scan = response_json.scan;
      this.scan.skip_rules = false;
      this.text = response_json.text;
      this.page_count = response_json.page_count;
      this.pdfUrl = response_json.pdf_url;
      this.isAttorneyReviewing = response_json.is_attorney_reviewing;
      this.isScanFininshed = response_json.is_scan_fininshed;
      this.isScanProcessing = response_json.is_scan_processing;
      this.isScannerReviewing = response_json.is_scanner_reviewing;
      this.intakeReleaseContext = response_json.intake_release_context || {};
      if(this.intakeReleaseContext.spreadsheet){
        this.scan.spreadsheet_release_format = this.intakeReleaseContext.spreadsheet_release_format || 'both';
      }
      if(this.intakeReleaseContext.suggested_document_type_id){
        this.scan.document_type_id = Number(this.intakeReleaseContext.suggested_document_type_id);
      }
      this.scanProblems = response_json.problems;
      this.scannerResponse = response_json.scanner_response;
      this.scanDates = this.uniqueScanDates(response_json.dates);
      this.areDatesPresent = this.scanDates.length > 1;
      this.scan.iframeUrl = this.authService.getAuthenticatedDownloadUrl(`${this.url + this.pdfUrl}`);
      this.scansService
          .getScanMatters({ scan_id: this.scanId })
          .then(response_json => {
            this.matters = response_json;
            this.oldMatters = response_json;
          });
      this.scansService.authors({scan_id: this.scanId})
        .then(response_json => {
          this.authors = response_json;
          this.oldAuthors = response_json;
        })
      this.getAvailableAuthors(this.scanId);
      if(this.scan.document_type_id){
        this.onDocumentTypeSelect(this.scan.document_type_id);
      }
    }).catch(error => {
      console.log("Scan edit error", error);
    });
  }
  
  onMatterSelect(event: any = null) {
    this.scansService.setScanMatter({scan_id: this.scanId, matter_id: event.id, scan: this.scanData()})
      .then(response_json => {
        this.matters = response_json;        
        this.getAvailableAuthors(this.scanId);
        this.scansService
          .getScanMatters({ scan_id: this.scanId })
          .then(response_json => {
            this.matters = response_json;
          });
      });
  }

  deleteMatter(matterId: number) {
    if(this.deletingMatter){
      return;
    }
    this.deletingMatter = true;
    this.scansService.destroyMatter({scan_id: this.scanId, matter_id: matterId})
      .then(response_json => {
        this.deletingMatter = false;
        this.matters = response_json;
        this.getAvailableAuthors(this.scanId);
        this.scansService
          .getScanMatters({ scan_id: this.scanId })
          .then(response_json => {
            this.matters = response_json;
          });
      }).catch(err => {
        console.error(err);
        this.deletingMatter = false;
      });
  }

  deleteScanConfirm() {
    this.deleteWarningMessage = 'Delete scan?';
    this.ngbModalService.open(this.confirmDeleteModalTemplateRef).result.then(
      (result) => {  
        this.deleting = true;    
        //TODO: use response_json.success to verify scan deletion after backend is changed to match it
        this.scansService.delete({id: this.scanId}).then(response_json => {
          this.deleting = false;
          this.notyService.notify("Scan deleted","success")
          this.router.navigateByUrl('/scans');
        }).catch(error => {          
          this.deleting = false;
          console.error('Scan delete error', error);
          this.notyService.notify("Error deleting scan","error")
        })   
        this.deleteWarningMessage = '';
      },
      (reason) => {
        // Cancelled
        this.deleteWarningMessage = '';
      }
    );
  }

  save(status: string) {
    this.released = true;
    let scanData: any = this.scanData();
    scanData.status = status;
    this.saving = true;
    this.scansService.release({scan: scanData}).then(response_json => {
      this.saving = false;
      if(response_json.errors){
        this.notyService.notify(response_json.errors,"error");
      }
      else{
        if(response_json.notice){
          this.notyService.notify(response_json.notice, response_json.notice_type || "success");
        }
        // TODO: Use angular routing in future
        const redirect = () => window.location.href = response_json.new_url || '/scans';
        response_json.notice ? setTimeout(redirect, 1800) : redirect();
      }
    }).catch(err=>{
      this.saving = false;
      console.log("release error", err);
    })
  }

  accept() {
    this.accepting = true;
    this.scansService.accept({scan: this.scanData()}).then(response_json => {
      if(response_json.new_url){
        this.accepting = false;
        window.location.href = response_json.new_url;
      }
    }).catch(err=>{
      this.accepting = false;
      console.log("accept error", err);
    })
  }

  deleteAuthor(author: any) {
    if(this.deletingAuthor){
      return;
    }
    this.deletingAuthor = true;
    this.scansService.destroyAuthor({id: author.scan_author_id, scan_id: this.scanId, isArray: true})
      .then(response_json => {
        this.authors = response_json;
        this.deletingAuthor = false;
      }).catch(err => {
        console.error(err);
        this.deletingAuthor = false;
      });
  }

  getAuthors(scan_id: number) {
    this.scansService.authors({scan_id: scan_id})
      .then(response_json => {
        this.authors = response_json;
      })
  }

  getAvailableAuthors(scan_id: number) {
    this.scansService.availableAuthors({scan_id: scan_id})
      .then(response_json => {
        // Available authors may not include a previously selected author
        // so we have to refresh the list
        this.availableAuthors = response_json;
        this.getAuthors(scan_id);
      });
  }

  onAuthorSelect(author: any) {
    //TODO: Refactor this to its own endpoint
    this.scansService.save({author, scan_id: this.scanId})
      .then(response_json => {
        this.authors = response_json;
        this.newScanAuthor = undefined;
      });
  }

  onDocumentTypeSelect(document_type_id: any) {
    this.scan.document_type_id = Number(document_type_id);
    this.documentTypeService.get(document_type_id, {get_document_type: true})
      .then(response_json => {
        this.documentType = response_json;
      })
  }

  clearDocumentType() {
    this.scan.document_type_id = null;
    this.documentType = {};
  }

  suggestedDocumentTypeIsCurrent() {
    if(!this.intakeReleaseContext.suggested_document_type_id || !this.scan.document_type_id) return false;

    return String(this.scan.document_type_id) === String(this.intakeReleaseContext.suggested_document_type_id);
  }

  canUseSuggestedDocumentType() {
    return !!this.intakeReleaseContext.suggested_document_type_id && !this.suggestedDocumentTypeIsCurrent();
  }

  useSuggestedDocumentType() {
    if(!this.intakeReleaseContext.suggested_document_type_id) return;

    this.onDocumentTypeSelect(this.intakeReleaseContext.suggested_document_type_id);
  }

  uniqueScanDates(rawDates: any) {
    const uniqueDates: Array<any> = [];
    const seenDates: any = {};
    (rawDates || []).forEach((dates: any) => {
      (dates || []).forEach((date: any) => {
        if(!date) return;

        const key = this.normalizedDateKey(date);
        if(seenDates[key]) return;

        seenDates[key] = true;
        uniqueDates.push(date);
      });
    });
    return uniqueDates;
  }

  normalizedDateKey(date: any) {
    const text = String(date).trim();
    const parsedDate = new Date(text);
    if(!isNaN(parsedDate.getTime())){
      const year = parsedDate.getFullYear();
      const month = `${parsedDate.getMonth() + 1}`.padStart(2, '0');
      const day = `${parsedDate.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return text.toLowerCase().replace(/\s+/g, ' ');
  }

  scanData() {
    return {
			amount: this.scan.amount,
			attorney_response: this.scan.attorneyResponse,
			authors: 			this.authors,
			authored_on: 		this.scan.authored_on,
			contents: 			this.text,
			document_id: 		this.scan.document_id,
			document_type_id: 	this.scan.document_type_id,
			exhibit: 			this.scan.exhibit,
			has_problems: 		this.scan.has_problems,
			id: 				this.scan.id,
			matters: 			this.matters, 
			notes: 			this.scan.notes,
			old_authors: this.oldAuthors,
			old_matters: this.oldMatters,
			page_count: 		this.page_count,
			priority:			this.scan.priority,
			problems: 			this.scan.problems,
			scanner_response: 	this.scan.scanner_response,
			skip_rules: 		this.scan.skip_rules,
			spreadsheet_release_format: this.scan.spreadsheet_release_format,
			tags: 				this.scan.tags
    }
  }
  // scan_data.attorney_response = $scope.editScan.attorneyResponse
  // scan_data.contents 			= document.getElementById('contents').value
  // scan_data.document_id 		= $scope.editScan.document_id
  // scan_data.old_authors 		= $scope.old_authors
	// scan_data.old_matters 		= $scope.old_matters
  // scan_data.page_count 		= document.getElementById('page_count').value
  // scan_data.problems 			= $scope.editScan.problems
  // scan_data.scanner_response 	= $scope.editScan.scanner_response
}
